<ng-container *ngIf="vm$ | async as vm">
  <div class="repeat-order-teaser__cards">
    <button mat-stroked-button *ngIf="vm.bulkCount > 0" class="repeat-order-teaser__button mat-non-underlined-button" routerLink="/repeat-order/bulk">
      <div class="repeat-order-button-wrapper">
        <mat-icon class="icon-small repeat-order-teaser__button-icon">add_shopping_cart</mat-icon>
        <span class="repeat-order-teaser__button-title">{{ 'repeat-order-teaser.open-bulk-order' | translate }}</span>
      </div>
    </button>
    <button
      *ngIf="vm.generalCargoCount > 0"
      mat-stroked-button
      class="repeat-order-teaser__button mat-non-underlined-button"
      routerLink="/repeat-order/packaged-goods"
    >
      <div class="repeat-order-button-wrapper">
        <mat-icon class="icon-small repeat-order-teaser__button-icon">add_shopping_cart</mat-icon>
        <span class="repeat-order-teaser__button-title">{{ 'repeat-order-teaser.open-general-cargo-order' | translate }}</span>
      </div>
    </button>
  </div>
</ng-container>
